import React from 'react';
import {
    View,
    VStack,
    HStack,
} from 'native-base';
import Signature from './Sign';
import { Caption, CaptionError, H3 } from './Typography';
import { useSpringBigStore, useTheme } from '@springbig/shared';
import Pressable from '~/shared/Pressable';
import { CheckBox, Modal, Button } from '~/shared/Theme';

export type AlertProps = {
    title: string;
    subHeaderText?: string;
    checkMessage?: boolean;
    signatureHeight?: number;
    setSignature?: (signature: string) => void;
    message: string
    showAlert: boolean
    setCancelAlert: (status: boolean) => void
    setAcceptAlert: (status: boolean) => void
    textConfirmButton?: string
    textCancelButton?: string
    showCancelButton?: boolean;
    testID?: string;
    type?: 'opt_in' | 'opt_out';
};

const Alert = ({
    signatureHeight,
    setSignature,
    checkMessage,
    subHeaderText,
    title,
    type,
    message,
    showAlert,
    setCancelAlert,
    setAcceptAlert,
    textCancelButton,
    textConfirmButton,
    showCancelButton = true,
}: AlertProps) => {

    const [checked, setChecked] =
        React.useState<boolean>(false);

    const [error, setError] =
        React.useState<string | null>(null);

    const { highlight_text } = useTheme();

    const { member } = useSpringBigStore();

    const handleAccept = () => {

        if (!checkMessage) {
            setAcceptAlert(false);
        }
        else if (checkMessage && !checked) {
            setError('Please accept the terms and conditions');
        }
        else if (checkMessage && checked) {
            setChecked(false);
            setAcceptAlert(false);
        }

    };

    const handleLinkPress = (url: string): void => {

        if (!url) {
            return;
        }

        window.open(url, '_blank');
    };

    return (
        <Modal
            isOpen={showAlert}
            closeable
            onClose={() => setCancelAlert(false)}
        >
            <Modal.Header>
                <H3 m={0}>{ title }</H3>
                {
                    subHeaderText && (
                        <Caption
                            fontSize={12}
                            fontWeight={'light'}
                        >
                            { subHeaderText }
                        </Caption>
                    )
                }
            </Modal.Header>

            <Modal.Body>
                <VStack space={4} h={signatureHeight || 'auto'}>
                    <HStack space={2}>
                        { checkMessage &&
                                <CheckBox
                                    value={'check'}
                                    isChecked={checked}
                                    onChange={(value) => {

                                        setError(null);
                                        setChecked(value);
                                    }}
                                />
                        }
                        <VStack w={'full'}>
                            <Caption
                                pr={checkMessage ? 6 : 0}
                                fontSize={12}
                            >
                                { message }
                            </Caption>
                            { type === 'opt_in' &&
                                <VStack>
                                    <Pressable
                                        onPress={() => handleLinkPress(member.terms_and_conditions_link)}
                                    >
                                        <Caption fontSize={11}>
                                            By completing this sign-up form and participating in our Program,
                                        </Caption>
                                        <Caption fontSize={11}>
                                            you consent to our
                                        </Caption>
                                        <Caption
                                            text={'profileMenu.terms_condition'}
                                            color={highlight_text}
                                            fontSize={11}
                                        />
                                    </Pressable>
                                    { member.privacy_policy_url &&
                                        <Pressable onPress={() => handleLinkPress(member.privacy_policy_url)}>
                                            <HStack space={1}>
                                                <Caption fontSize={11}>and our </Caption>
                                                <Caption
                                                    text={'profileMenu.privacy_policy'}
                                                    color={highlight_text}
                                                    fontSize={11}
                                                />
                                            </HStack>
                                        </Pressable>
                                    }
                                </VStack>
                            }
                        </VStack>
                    </HStack>
                    {
                    <View h={signatureHeight ? 250 : 150}>
                        <Signature
                            onChange={value => {

                                setError(null);
                                setSignature && setSignature(value);
                            }}
                        />
                    </View>
                    }
                </VStack>
                { error &&
                    <CaptionError fontSize={11} textAlign='center'>
                        { error }
                    </CaptionError>
                }
            </Modal.Body>
            <Modal.Footer>
                <HStack space={4}>
                    { showCancelButton ?
                        <Button
                            text={textCancelButton || 'Cancel'}
                            variant={'neutral'}
                            onPress={() => {

                                setError(null);
                                setChecked(false);
                              setCancelAlert!(false);
                            }}
                        />
                        : null
                    }
                    <Button
                        text={textConfirmButton || 'Accept'}
                        onPress={() => {

                            handleAccept();
                        }}
                    />
                </HStack>
            </Modal.Footer>
        </Modal>
    );
};

export default Alert;
